// extracted by mini-css-extract-plugin
module.exports = {"conteinar":"_7144"};